import _ from 'lodash'
import { v4 as uuidv4 } from 'uuid'

import GlassDesignerTypes from '../types'
import { OrderTypes } from '@/store/types'

/*
 * Order
 * Represents an Order (from server) that is used to keep details for the Order
 * Relevent properties used by the editor should match Order server database model
 */
export default class Order {
  constructor(orderData = {}) {
    this.id = orderData.id || null
    this.contactId = orderData.contactId || null
    this.salesRateId = orderData.salesRateId || null
    this.type = orderData.type || OrderTypes.order
    this.isUrgent = !!orderData.isUrgent
    this.sequenceNumber = orderData.sequenceNumber || ''

    this.notes = orderData.notes || ''
    this.customerRef = orderData.customerRef || ''

    this.despatchType = orderData.despatchType    // TODO: Remove in future
    this.despatchTaskTypeId = orderData.despatchTaskTypeId
    this.deliveryAddress1 = orderData.deliveryAddress1 || ''
    this.deliveryAddress2 = orderData.deliveryAddress2 || ''
    this.deliverySuburb = orderData.deliverySuburb || ''
    this.deliveryState = orderData.deliveryState || ''
    this.deliveryPostcode = orderData.deliveryPostcode || ''
    this.deliveryCountry = orderData.deliveryCountry || ''
    
    // Editor details
    this.deliveryStockId = orderData.deliveryStockId || 0
    this.deliveryFeeAmount = orderData.deliveryFeeAmount || 0
    this.deliveryTag = orderData.deliveryTag || []

    // All order items (panels & other)
    // Flattened
    this.orderItems = []

    // Pricing
    this.totalTax = 0
    this.totalPrice = 0
  }


  /**
   * Update the order details
   */
  updateDetails(orderData) {
    this.id = orderData.id
    this.type = orderData.type
    this.contactId = orderData.contactId
    this.salesRateId = orderData.salesRateId
    this.isUrgent = orderData.isUrgent
    this.sequenceNumber = orderData.sequenceNumber

    this.notes = orderData.notes
    this.customerRef = orderData.customerRef

    this.despatchType = orderData.despatchType    // TODO: Remove in future
    this.despatchTaskTypeId = orderData.despatchTaskTypeId
    this.deliveryAddress1 = orderData.deliveryAddress1
    this.deliveryAddress2 = orderData.deliveryAddress2
    this.deliverySuburb = orderData.deliverySuburb
    this.deliveryState = orderData.deliveryState
    this.deliveryPostcode = orderData.deliveryPostcode
    this.deliveryCountry = orderData.deliveryCountry

    this.deliveryStockId = orderData.deliveryStockId
    this.deliveryFeeAmount = orderData.deliveryFeeAmount
    this.deliveryTag = orderData.deliveryTag

    this.orderItems = _.cloneDeep(orderData.orderItems || [])
  }


  /**
   * Add a new order item to the list
   */
  addOrderItem(orderItem) {
    this.orderItems.push(orderItem)
  }


  /**
   * Get an order item by an ID
   * Returns null if the order item was not found
   */
  getOrderItemById(id) {
    return this.orderItems.find(orderItem => orderItem.id == id)
  }


  /**
   * Check if an order is an NCR type order
   */
  isNCROrder() {
    return this.type == OrderTypes.nonChargeableRework
  }


  // Serialize/Deserialize to/from a JSON object
  serialize() {
    var outputData = {}

    return outputData
  }
  deserialize(object) {

  }
}
